module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (141).e936a9ff.jpg";